import {createApp} from 'vue'
import FundraisingQrCodeOverlay from './FundraisingQrCodeOverlay'
import handleComponentProps from 'foundation/js/utils/handleComponentProps'

const el = '.kb-component--fundraising-qr-code-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FundraisingQrCodeOverlayDOM)=> {
            const props = handleComponentProps(FundraisingQrCodeOverlay, FundraisingQrCodeOverlayDOM)
            const component = createApp(FundraisingQrCodeOverlay, props).use(Store)
            component.mount(FundraisingQrCodeOverlayDOM)
        })
    }
}